import { formatCellValue,formatDateForDisplay } from "../../Utils/UtilityFunctions";
export const PoliciesColoumn = () => {
  const columns = [
    {
      accessorKey: 'policyId',
      header: 'Policy ID',
      size: 150,
       Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'policyLabel',
      header: 'Policy Label',
      size: 150,
       Cell: ({ cell }) => formatCellValue(cell.getValue())    
    },
    {
      accessorKey: 'resourceName',
      header: 'Resource',
      size: 150,
       Cell: ({ cell }) => formatCellValue(cell.getValue())    
    },
  ];

  return columns;
};